import { ITableFieldDictionary } from 'src/app/interfaces/field-settings.interface';
import { DataTypes } from 'src/shared/enums/data-type.enum';

const calibrationGeneralDictionary: ITableFieldDictionary = {
    // Building Configuration
    PrincipalMaxHeightLvl: { label: 'Principal Building Maximum Levels (Podium)', type: DataTypes.INTEGER, isRequired: true },
    PrincipalBuildingMin: { label: 'Principal Building Minimum Levels (Podium)', type: DataTypes.INTEGER },
    PrincipalMaxHeightFt: { label: 'Principal Building Max. Height (Podium)', type: DataTypes.FLOAT },
    PrincipalMinHeightFt: { label: 'Principal Building Minimum Height (Podium)', type: DataTypes.FLOAT },
    Outbuilding: { label: 'Outbuilding Maximum Levels', type: DataTypes.INTEGER },
    ActivePrimaryFrontageGround: { label: 'Active Principal Frontage Ground Level', type: DataTypes.BOOLEAN },
    ActivePrimaryFrontageAbove: { label: 'Active Principal Frontage Above Ground', type: DataTypes.BOOLEAN },
    ActiveSecondaryFrontageGround: { label: 'Active Secondary Frontage Ground Level', type: DataTypes.BOOLEAN },
    ActiveSecondaryFrontageAbove: { label: 'Active Secondary Frontage Above Ground', type: DataTypes.BOOLEAN },
    ActiveWaterFrontageGround: { label: 'Active Natural Feature Frontage Ground Level', type: DataTypes.BOOLEAN },
    ActiveWaterFrontageAbove: { label: 'Active Natural Feature Frontage Above Ground', type: DataTypes.BOOLEAN },
    FacadePrimaryFrontage: { label: 'Minimum Active Principal Frontage', type: DataTypes.FLOAT },
    FacadeSecondaryFrontage: { label: 'Minimum Active Secondary Frontage', type: DataTypes.FLOAT },
    PkgFacadeWidthMax: { label: 'Parking Entrance Maximum Width at Principal Frontage', type: DataTypes.FLOAT },
    TowerMaxHeightLvl: { label: 'Tower Maximum Levels (Including Podium)', type: DataTypes.INTEGER },
    PenthouseMaxHeightLvl: { label: 'Penthouse Maximum Levels (Including Podium and Tower)', type: DataTypes.INTEGER },
    TowerMaxHeightFt: {
        label: 'Total Maximum Height (Including Podium, Tower and Penthouse)',
        type: DataTypes.INTEGER
    },

    // Lot Occupation
    LotAreaMin: { label: 'Lot Area Minimum', type: DataTypes.FLOAT },
    LotAreaMax: { label: 'Lot Area Maximum', type: DataTypes.FLOAT },
    LotAreaMinAlley: { label: 'Lot Area Minimum Alley', type: DataTypes.FLOAT },
    LotAreaMaxAlley: { label: 'Lot Area Maximum Alley', type: DataTypes.FLOAT },
    LotWidthMin: { label: 'Lot Width Minimum', type: DataTypes.FLOAT },
    LotWidthMinAlley: { label: 'Lot Width Minimum Alley', type: DataTypes.FLOAT },
    LotWidthMax: { label: 'Lot Width Maximum', type: DataTypes.FLOAT },
    GreenSpace: { label: 'Minimum Green Open Space', type: DataTypes.FLOAT, isRequired: true },
    LotCoverageFirstFloor: { label: 'Maximum Building Coverage', type: DataTypes.FLOAT, isRequired: true },
    LotCoverageSecondFloor: { label: 'Maximum Building Coverage 2nd Level', type: DataTypes.FLOAT },
    TowerFloorplateAreaResidential: { label: 'Tower Floorplate Area Residential', type: DataTypes.FLOAT },
    TowerFloorplateAreaCommercial: { label: 'Tower Floorplate Area Commercial', type: DataTypes.FLOAT },
    PenthouseFloorPlate: { label: 'Penthouse Floorplate Area', type: DataTypes.FLOAT },
    SecondLayerDimension: { label: 'Minimum Depth of Active Frontage', type: DataTypes.FLOAT },
    FLR: { label: 'Global Floor Land Ratio (FLR)', type: DataTypes.FLOAT },

    // Setbacks - Principal
    PFrontSetbackPrincipal: { label: 'Minimum Principal Frontage Setback', type: DataTypes.FLOAT, isRequired: true },
    PFrontSetbackPrincipalMax: { label: 'Maximum Principal Frontage Setback', type: DataTypes.FLOAT },
    PFrontSetbackSecondary: { label: 'Minimum Secondary Frontage Setback', type: DataTypes.FLOAT, isRequired: true },
    PFrontSetbackSecondaryMax: { label: 'Maximum Secondary Frontage Setback', type: DataTypes.FLOAT },
    PWaterSetback: { label: 'Minimum Natural Feature Frontage Setback', type: DataTypes.INTEGER },
    PSideSetback: { label: 'Minimum Side Setback', type: DataTypes.FLOAT, isRequired: true },
    PSideSetbackMax: { label: 'Maximum Side Setback', type: DataTypes.FLOAT },
    PSplitSideSetback: { label: 'Split Setback', type: DataTypes.BOOLEAN },
    PRearSetback: { label: 'Minimum Rear Setback', type: DataTypes.FLOAT, isRequired: true },
    PRearSetbackMax: { label: 'Maximum Rear Setback', type: DataTypes.FLOAT },

    // Setbacks - Outbuilding
    OFrontSetbackPrincipal: { label: 'Minimum Principal Frontage Setback', type: DataTypes.FLOAT },
    OSideSetback: { label: 'Minimum Side Setback', type: DataTypes.FLOAT },
    OSideSetbackAtCorner: { label: 'Minimum Secondary Frontage Setback', type: DataTypes.FLOAT },
    ORearSetback: { label: 'Minimum Rear Setback', type: DataTypes.FLOAT },

    // Setbacks - Tower
    TFrontSetbackPrincipal: { label: 'Minimum Principal Frontage Setback', type: DataTypes.FLOAT },
    TFrontSetbackPrincipalMax: { label: 'Maximum Principal Frontage Setback', type: DataTypes.FLOAT },
    TFrontSetbackSecondary: { label: 'Minimum Secondary Frontage Setback', type: DataTypes.FLOAT },
    TFrontSetbackSecondaryMax: { label: 'Maximum Secondary Frontage Setback', type: DataTypes.FLOAT },
    TWaterSetback: { label: 'Minimum Natural Feature Frontage Setback', type: DataTypes.FLOAT },
    TSideSetback: { label: 'Minimum Side Setback', type: DataTypes.FLOAT },
    TSideSetbackMax: { label: 'Maximum Side Setback', type: DataTypes.FLOAT },
    TRearSetback: { label: 'Minimum Rear Setback', type: DataTypes.FLOAT },
    TRearSetbackMax: { label: 'Maximum Rear Setback', type: DataTypes.FLOAT },
    TSetbackBetweenTowers: { label: 'Setback between towers', type: DataTypes.FLOAT },

    // Setbacks - Penthouse
    PeFrontSetbackPrincipal: { label: 'Minimum Principal Frontage Setback', type: DataTypes.FLOAT },
    PeFrontSetbackPrincipalMax: { label: 'Maximum Principal Frontage Setback', type: DataTypes.FLOAT },
    PeFrontSetbackSecondary: { label: 'Minimum Secondary Frontage Setback', type: DataTypes.FLOAT },
    PeFrontSetbackSecondaryMax: { label: 'Maximum Secondary Frontage Setback', type: DataTypes.FLOAT },
    PeSideSetback: { label: 'Minimum Side Setback', type: DataTypes.FLOAT },
    PeSideSetbackMax: { label: 'Maximum Side Setback', type: DataTypes.FLOAT },
    PeRearSetback: { label: 'Minimum Rear Setback', type: DataTypes.FLOAT },
    PeRearSetbackMax: { label: 'Maximum Rear Setback', type: DataTypes.FLOAT },

    // Setbacks - Underground
    UFrontSetbackPrincipal: { label: 'Minimum Principal Frontage Setback', type: DataTypes.FLOAT },
    UFrontSetbackSecondary: { label: 'Minimum Secondary Frontage Setback', type: DataTypes.FLOAT },
    USideSetback: { label: 'Minimum Side Setback', type: DataTypes.FLOAT },
    URearSetback: { label: 'Minimum Rear Setback', type: DataTypes.FLOAT },

    // Private Frontages
    CommonLawn: { label: 'Common Lawn', type: DataTypes.BOOLEAN },
    PorchAndFence: { label: 'Porch and Fence', type: DataTypes.BOOLEAN },
    TerraceOrLightwell: { label: 'Terrace or Lightwell', type: DataTypes.BOOLEAN },
    Forecourt: { label: 'Forecourt', type: DataTypes.BOOLEAN },
    Stoop: { label: 'Stoop', type: DataTypes.BOOLEAN },
    Shopfront: { label: 'Shopfront', type: DataTypes.BOOLEAN },
    Gallery: { label: 'Gallery', type: DataTypes.BOOLEAN },
    Arcade: { label: 'Arcade', type: DataTypes.BOOLEAN }
};

export default calibrationGeneralDictionary;
